import { render, staticRenderFns } from "./importBatchManage.vue?vue&type=template&id=3ce20941&scoped=true"
import script from "./importBatchManage.vue?vue&type=script&lang=js"
export * from "./importBatchManage.vue?vue&type=script&lang=js"
import style0 from "./importBatchManage.vue?vue&type=style&index=0&id=3ce20941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce20941",
  null
  
)

export default component.exports